import { Tabs } from "flowbite-react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button } from "flowbite-react";

// import logo from "images/mirum-logo.png";
import useAccount from "hooks/useAccount";
import BubblesBg from "components/BubblesBg";
import { Animated } from "react-animated-css";
import useAPI from "hooks/useAPI";
import { useEffect, useState } from "react";
import { FiPlus } from "react-icons/fi";
import Bookings from "./components/Bookings";
import moment from "moment";
import useBookings from "hooks/useBookings";
import { FaChevronDown, FaUser, FaUserAlt } from "react-icons/fa";
import UserNavMenu from "components/Header/components/UserNavMenu";
import Footer from "components/Footer";
import { useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";

const DashBoard = () => {
  const user = useSelector((state) => state.auth.user);
  const { userIsLoggedIn } = useAccount();
  const isLoggedIn = userIsLoggedIn(user);
  const history = useHistory();
  const { API } = useAPI({});
  const [bookings, setBookings] = useState([]);
  const [nextBooking, setNextBooking] = useState({});
  const [surprisesToConfirm, setSurprisesToConfirm] = useState([]);
  const [showStatus, setShowStatus] = useState(null);

  useEffect(() => {
    if (!userIsLoggedIn(user)) {
      goToLogin();
    } else {
      let params = new URLSearchParams(window.location.search);
      let sId = params.get("sid");
      if (sId) {
        params.delete("sid");
        loadAndGoToBooking(sId);
      } else {
        getAndSetBookings();
      }
    }
  }, [user]);

  useEffect(() => {
    if (bookings.length > 0) {
      let nextBooking = bookings.filter(
        (booking) => booking.status === "confirmed"
      )[0];

      //Assume they've fullfilled it after 24h
      if (nextBooking?._id) {
        let hasBeenFulfilled = moment().isAfter(
          moment
            .unix(nextBooking.stripe.paymentIntent.created)
            .add("24", "hours")
        );
        nextBooking = { ...nextBooking, hasBeenFulfilled };
      }

      setNextBooking(nextBooking);

      const surprisesToConfirm = bookings.filter(
        (booking) => booking.status === "draft" && bookingHasBeenPaid(booking)
      );
      setSurprisesToConfirm(surprisesToConfirm);
    }
  }, [bookings]);

  const goToLogin = () => {
    let url = "/login";
    const params = new URLSearchParams(window.location.search);
    if (params) {
      let surpriseId = params.get("sid");
      if (surpriseId) {
        url += `?sid=${surpriseId}`;
      }
    }
    history.push(url);
  };

  const getAndSetBookings = async () => {
    const data = await API.get(`/bookings`);
    setBookings(data?.bookings);
  };

  const handleClickNewSurprise = () => {
    // clearSelection();
    history.push("/new");
  };

  const { getAndSetSelectionByBookingId, bookingHasBeenPaid } = useBookings();
  const loadAndGoToBooking = async (bookingId) => {
    await getAndSetSelectionByBookingId(bookingId);
    history.push(`/where`);
  };

  const deleteBooking = async (bookingId) => {
    await API.del(`/bookings/${bookingId}`);
    await getAndSetBookings();
  };

  const scrollToBookings = () => {
    document.getElementById("bookings").scrollIntoView &&
      document.getElementById("bookings").scrollIntoView();
  };

  const Summary = ({ className }) => {
    return (
      <div
        className={`container mx-auto grid grid-cols-2 md:flex text-center items-start justify-center gap-2 ${className}`}
      >
        {surprisesToConfirm.length > 0 && (
          <div className="md:w-1/3 text-center">
            <img
              src="/images/icons/confirm-surprises.png"
              className="w-[50px] mx-auto m-4"
            />
            <span>
              you’ve got {surprisesToConfirm.length} surprise
              {surprisesToConfirm.length > 0 && "s"} waiting to be confirmed
              <span className="hidden md:inline">
                <br />
                please select your preferences when you’re ready
              </span>
            </span>
            <br />
            <a
              onClick={() => {
                // loadAndGoToBooking(surprisesToConfirm[0]._id);
                setShowStatus("draft");
                scrollToBookings();
              }}
              className="text-[var(--peachy-pink)] cursor-pointer font-bold"
            >
              view
            </a>
          </div>
        )}
        {nextBooking?._id && (
          <div className="md:w-1/3 md:text-center">
            <img
              src="/images/icons/upcoming-surprise.png"
              className="w-[50px] mx-auto m-4"
            />
            <span className="lowercase">
              <strong>Upcoming: </strong>
              {moment(nextBooking?.selection?.when?.date).format("Do MMMM")}
              &nbsp;@&nbsp;
              {nextBooking?.selection?.when?.startTime}
            </span>
            <br />
            <a
              className="text-[var(--peachy-pink)] cursor-pointer font-bold"
              onClick={() => {
                loadAndGoToBooking(nextBooking._id);
              }}
            >
              view
            </a>
          </div>
        )}
        {nextBooking?._id && !nextBooking.hasBeenFulfilled && (
          <div className="md:w-1/3 text-center">
            <img
              src="/images/icons/preparing-surprise.png"
              className="w-[50px] mx-auto m-4"
            />
            <span>
              we’re preparing your surprise for{" "}
              {moment(nextBooking?.selection?.when?.date).format("Do MMMM")}.
            </span>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <Helmet>
        <title>your surprises</title>
      </Helmet>

      <div className="w-full" style={{ backgroundColor: "#FDFBFD" }}>
        <BubblesBg />
        <div className="z-10 flex flex-col">
          {/* HEADER */}
          <header className="w-full sticky top-0 left-0 z-20">
            <div className="">
              {/* NAV */}
              <div className="bg-white p-6">
                <div className="text-right  container mx-auto ">
                  <div className="inline-block top-[13px]  z-10 absolute top-0 right-0 md:p-0">
                    {isLoggedIn && <UserNavMenu isLoggedIn={isLoggedIn} />}
                  </div>

                  {/* {isLoggedIn && (
              <Button
                onClick={() => {
                  logout();
                }}
              >
                Log out
              </Button>
            )} */}
                  {!isLoggedIn && (
                    <Button
                      onClick={() => {
                        goToLogin();
                      }}
                    >
                      Login
                    </Button>
                  )}
                </div>
              </div>
              {/* LOGO */}
              <div
                className="w-full w-10/12 md:w-1/2 mx-auto flex-col grow w-full items-center justify-center relative md:top-[-30px]"
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img
                  src="/images/header-oval.png"
                  className="relative w-[200%] md:w-[150%] top-[-2px]"
                />
                <div className="hidden md:block absolute top-0 left-0 flex flex-col justify-center items-center">
                  <img
                    src={"/images/mirum-logo.png"}
                    className=" mx-auto w-4/12 md:w-1/4 md:mt-5"
                  />

                  <h4 className="hidden md:block font-light text-center w-full p-4">
                    let us surprise you
                  </h4>
                </div>
                <div className="md:hidden absolute top-[-100%] left-0 w-full flex items-center justify-center">
                  <img src="/webclip.png" className="w-4/12" />
                </div>
              </div>
            </div>
          </header>

          <div className="container mx-auto">
            <div className="mt-10 w-full pt-5 md:mt-0 md:p-8 ">
              <h1 className="text-center w-full">Your Surprises</h1>
            </div>
          </div>

          {/* SUMMARY DESKTOP */}
          <Summary className="hidden md:block" />

          {/* ADD BUTTON */}
          <div className="container mx-auto flex justify-center p-8">
            <Animated animationIn="pulse">
              <button
                onClick={handleClickNewSurprise}
                class="rounded-full text-white py-4 px-8 hover:scale-105 transform transition duration-300 ease-in-out"
                style={{
                  backgroundColor: "#ED697E",
                  boxShadow: "0 0 20px 10px rgba(0,0,0,0.1)",
                  border: "1px solid rgba(255,255,255,0.2)",
                }}
              >
                <h4 className="flex items-center gap-3 relative">
                  <FiPlus />
                  <span>new surprise</span>
                </h4>
              </button>
            </Animated>
          </div>

          {/* SUMMARY MOBILE */}
          <Summary className="block md:hidden px-4" />

          {/* BOOKINGS / TABS */}
          <div
            className="pt-[10%] grow z-2"
            style={{
              backgroundImage: "url('/images/bg-swirl-white.png')",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              backgroundPosition: "top right",
            }}
          >
            <div
              style={{
                backgroundColor: "white",
              }}
            >
              <div className="container mx-auto" id="bookings">
                <Bookings
                  bookings={bookings}
                  loadAndGoToBooking={loadAndGoToBooking}
                  onClickedNewSurprise={handleClickNewSurprise}
                  showStatus={showStatus}
                  deleteBooking={deleteBooking}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default DashBoard;
